import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The framework uses the following definition of an AI system: `}</p>
    <p><strong parentName="p">{`AI System`}</strong>{` - An AI system is a machine-based system that can, for a given set of human-defined objectives,
make predictions, recommendations, or decisions influencing real or virtual environments. AI systems are designed
to operate with varying levels of autonomy. `}</p>
    <p>{`The framework classifies systems along two dimensions, autonomy and impact. Autonomy is defined as:`}</p>
    <p><strong parentName="p">{`Autonomy`}</strong>{` - The degree to which a system has the capability to perform a set of human-defined objectives and
generate decisions, predictions, or recommendations without human involvement, outside of set-up and
routine maintenance. The framework includes four levels of autonomy:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`High Autonomy`}</strong>{` - During normal operation the system has capability for self-governance and the ability to
adapt to uncertainty without human involvement. System evaluates input and executes a decision action without
human involvement. Human involvement is only a factor during system set-up and routine maintenance and monitoring.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Medium Autonomy`}</strong>{` - During normal operation the system has limited capability for self-governance and requires
human involvement to perform designated tasks. System evaluates input without human involvement and provides
predictions or recommendations for human adjudication and decision execution. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Low Autonomy`}</strong>{` - During normal operation the system requires human involvement to overcome uncertainty
and provide ultimate decision-making authority. System evaluates input without human involvement and
identifies or flags information for human adjudication and decision execution. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`No Autonomy`}</strong>{` - During normal operation the system requires human involvement in all system processes
for proper function. The system cannot autonomously produce a decision, prediction, or recommendation
without direct human interaction.`}</p>
      </li>
    </ul>
    <p>{`Impact is defined as:`}</p>
    <p><strong parentName="p">{`Impact`}</strong>{` - The potential consequences of system-directed decisions for physical and system safety,
national security, civil rights and liberties, and enterprise operations (including the ability to execute
core functions or implement decisions without external challenge). The framework includes three levels of impact:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`High Impact`}</strong>{` - The decision outcome could lead to death or bodily harm, grave risk to national security,
violation of civil rights or liberties, or significant disruption of core enterprise goals or functions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Medium Impact`}</strong>{` - The decision outcome could lead to risk to systems and/or network security, diminished
livelihood (e.g., financial harm), or mitigable disruption of core enterprise goals or functions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Low Impact`}</strong>{` - The decision outcome has little to no effect on physical safety, national or system security,
civil rights or liberties, or core enterprise goals or functions. The decision is unlikely to cause any
significant or permanent damage.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      